import { setAudioModeAsync, useAudioPlayer } from "expo-audio";
import { useCallback } from "react";

// Countdown/record-start tone (1000Hz, 200ms).
const beepSource = require("../assets/beep.wav");

export type UseBeepResult = {
	play: () => void;
};

const useBeep = (): UseBeepResult => {
	const player = useAudioPlayer(beepSource);

	const play = useCallback(() => {
		const run = async () => {
			try {
				await setAudioModeAsync({
					playsInSilentMode: true,
				});
				await player.seekTo(0);
				player.play();
			} catch {
				// Audio unavailable — safe no-op.
			}
		};
		run();
	}, [player]);

	return { play };
};

export default useBeep;
